import { z } from 'zod';
import { SUBSCRIPTION_TIERS } from '../constants/subscriptionTiers.js';
const TIER_VALUES = Object.keys(SUBSCRIPTION_TIERS);
const PAID_TIER_VALUES = ['plus', 'pro', 'max'];
export const SubscriptionStatusSchema = z.enum([
    'active',
    'trialing',
    'past_due',
    'canceled',
    'incomplete',
    'unpaid',
]);
export const SubscriptionSourceSchema = z.enum(['stripe', 'admin', 'trial']);
// ─── Responses ────────────────────────────────────────────────────────────
export const EntitlementsSchema = z.object({
    lessonsPerMonth: z.number().int().nonnegative(),
    imageSearch: z.boolean(),
    imageGenerate: z.boolean(),
    analysisPerDay: z.number().int().nonnegative(),
    chatMessagesPerDay: z.number().int().nonnegative(),
    aiGradingPerDay: z.number().int().nonnegative(),
});
export const UsageSchema = z.object({
    lessonsUsed: z.number().int().nonnegative(),
    lessonsRemaining: z.number().int().nonnegative(),
    periodStart: z.string().datetime().nullable(),
    periodEnd: z.string().datetime().nullable(),
    hasInFlightGeneration: z.boolean(),
});
export const SubscriptionResponseSchema = z.object({
    tier: z.enum(TIER_VALUES),
    status: SubscriptionStatusSchema.nullable(),
    source: SubscriptionSourceSchema.nullable(),
    cancelAtPeriodEnd: z.boolean(),
    entitlements: EntitlementsSchema,
    usage: UsageSchema,
});
// ─── Admin requests ────────────────────────────────────────────────────────
export const GrantSubscriptionSchema = z.object({
    userId: z.string().uuid(),
    tier: z.enum(PAID_TIER_VALUES),
    note: z.string().max(500).optional(),
});
export const ChangeTierSchema = z.object({
    tier: z.enum(PAID_TIER_VALUES),
    note: z.string().max(500).optional(),
});
export const CancelSubscriptionSchema = z.object({
    immediate: z.boolean().default(false),
    note: z.string().max(500).optional(),
});
export const ReactivateSubscriptionSchema = z.object({
    note: z.string().max(500).optional(),
});
export const SubscriptionIdParamSchema = z.object({
    subscriptionId: z.string().uuid(),
});
export const ListSubscriptionsQuerySchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    pageSize: z.coerce.number().int().positive().max(100).default(20),
    tier: z.enum(PAID_TIER_VALUES).optional(),
    status: SubscriptionStatusSchema.optional(),
});
// ─── Audit log ─────────────────────────────────────────────────────────────
export const SubscriptionAuditActionSchema = z.enum([
    'granted',
    'tier_changed',
    'canceled',
    'reactivated',
    'period_rolled',
    'webhook_update',
]);
export const SubscriptionAuditLogEntrySchema = z.object({
    id: z.string().uuid(),
    subscription_id: z.string().uuid(),
    actor_user_id: z.string().uuid().nullable(),
    action: SubscriptionAuditActionSchema,
    from_state: z.unknown().nullable(),
    to_state: z.unknown().nullable(),
    note: z.string().nullable(),
    created_at: z.string(), // ISO timestamp; Prisma serialises DateTime to string over JSON
});
//# sourceMappingURL=subscription.schema.js.map